import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Font from '@cred/react-font'
import { getKeyDownProps } from './utils'
import styles from './styles.module.scss'

class Link extends Component {
  static propTypes = {
    type: PropTypes.string,
    href: PropTypes.string,
    color: PropTypes.string,
    underline: PropTypes.oneOf(['none', 'dashed', 'solid']),
    blank: PropTypes.bool,
    rel: PropTypes.string,
    tabIndex: PropTypes.number,
    onKeyDown: PropTypes.func,
    ignoreKeyDown: PropTypes.bool,
  }

  static defaultProps = {
    type: 'inherit',
    href: null,
    color: 'secondary',
    underline: 'none',
    blank: false,
    rel: '',
    tabIndex: 0,
    onKeyDown: undefined,
    ignoreKeyDown: false
  }

  constructor(props) {
    super(props)

    this.onClickHandler = this.onClickHandler.bind(this)
    this.setRef = this.setRef.bind(this)
  }

  onClickHandler(proxy) {
    const {onClick} = this.props

    if (onClick) {
      onClick(proxy)
    }
  }

  setRef(ref) {
    this.ref = ref
  }

  click() {
    if (this.ref) {
      this.ref.click()
    }
  }

  focus() {
    if (this.ref) {
      this.ref.focus()
    }
  }

  render() {
    const {
        underline,
        blank,
        className,
        href,
        onClick,
        rel,
        analytics,
        defaultAnalytics,
        match,
        location,
        history,
        staticContext,
        analyticsContexts,
        analyticsOptions,
        overwriteContexts,
        snowplowEvent,
        analyticsText,
        tabIndex,
        onKeyDown,
        ignoreKeyDown,
        ...props
      } = this.props,
      mergedStyles = [className, styles[underline], styles.link]

      const keyDownProps = getKeyDownProps({onKeyDown, ignoreKeyDown, href})

    let safeRel = rel

    if ((blank || (props.target || '').toLowerCase() === '_blank') && !rel.includes('noopener')) {
      safeRel += ' noopener'
    }

    return (
      <Font element="a"
        className={mergedStyles.join(' ')}
        href={href}
        rel={safeRel.trim()}
        ref={this.setRef}
        onClick={this.onClickHandler}
        target={blank ? '_blank' : '_self'}
        tabIndex={tabIndex}
        {...keyDownProps}
        {...props}
      />
    )
  }
}

export {Link}

export default Link
